import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { api } from 'app/api'
import { ItemType } from 'app/common/ui-next/plain-selector'

import { orgsFilterSelection } from './orgsFilter'
import { schoolYearFilterSelection } from './schoolYearFilter'
import { DayCaresListType } from 'app/dataTypes/dayCaresList'
import { GET_DAY_CARES_LIST, convertParams, convertResult } from 'app/common/api/requests/reports/day_cares_list/get'


type DayCaresList = Array<ItemType>

class DayCaresListFilterDataBox extends DataBox<DayCaresList> { }

export const defaultDayCaresList: DayCaresList = []
export const dayCaresListFilter = createDataBox('dayCaresListFilter', defaultDayCaresList, DayCaresListFilterDataBox)

const convertFromExtended = (dayCaresList: DayCaresListType): DayCaresList => {
  return dayCaresList.map(({ ID, title }) => ({ id: ID, title }))
}


export const defaultDayCaresListDataReceiver = async () => {
  const orgIds = orgsFilterSelection.getData()
  const orgId = orgIds[0]
  const yearIds = schoolYearFilterSelection.getData()
  const yearId = yearIds[0]
  if (!orgId || !yearId) return []

  const res = await api.request(GET_DAY_CARES_LIST, {
    error: 'Не удалось получить данные ГПД',
    params: {
      schoolId: orgId,
      schoolYearId: yearId,
    },
    convertions: {
      convertParams,
      convertResult,
    },
  })
  return res ? convertFromExtended(res) : []
}


export const defaultDayCaresListSelection: Array<string> = []
export const dayCaresListFilterSelection = createDataBoxDefault<Array<string>>('dayCaresListFilterSelection', defaultDayCaresListSelection)
